// 图片配置文件 - 自动生成，请勿手动修改
// 生成时间: 2025-08-20T08:11:22.824Z

import { resolveImageAssetUrl, toImageAssets, type ImageAsset, type ImageAssetLike } from '../types/imageAsset';

// 定义类型
type RawPhotoGroup = {
    [key: number]: string[];
};

type RawPhotoConfig = {
    [key: string]: RawPhotoGroup;
};

type PhotoGroup = {
    [key: number]: ImageAsset[];
};

type PhotoConfig = {
    [key: string]: PhotoGroup;
};

// 图片路径配置 - 基于实际文件结构
const RAW_PHOTO_CONFIG: RawPhotoConfig = {
    "A": {
        "1": [
            "/photos/A1/000001.JPG",
            "/photos/A1/000002.JPG",
            "/photos/A1/000003.JPG",
            "/photos/A1/000004.JPG",
            "/photos/A1/aed00478f686ec8c43fa592149363528.jpg"
        ],
        "2": [
            "/photos/A2/000005.JPG",
            "/photos/A2/000006.JPG",
            "/photos/A2/000027.JPG",
            "/photos/A2/000028.JPG",
            "/photos/A2/微信图片_2025-08-20_153920_143.jpg"
        ],
        "3": [
            "/photos/A3/000029.JPG",
            "/photos/A3/000030.JPG",
            "/photos/A3/000031.JPG",
            "/photos/A3/000032.JPG",
            "/photos/A3/微信图片_20250820154127_73.jpg"
        ],
        "4": [
            "/photos/A4/000033.jpg",
            "/photos/A4/000034.jpg",
            "/photos/A4/000037.jpg",
            "/photos/A4/000038.jpg",
            "/photos/A4/微信图片_20250820154020_65.jpg",
            "/photos/A4/微信图片_20250820154029_66.jpg"
        ],
        "5": [
            "/photos/A5/000035.JPG",
            "/photos/A5/000036.JPG",
            "/photos/A5/000039.JPG",
            "/photos/A5/000040.JPG",
            "/photos/A5/000044.JPG",
            "/photos/A5/微信图片_20250820154039_67.jpg",
            "/photos/A5/微信图片_20250820154045_68.jpg"
        ],
        "6": [
            "/photos/A6/000041.jpg",
            "/photos/A6/000042.jpg",
            "/photos/A6/000043.jpg",
            "/photos/A6/000045.jpg",
            "/photos/A6/000099.jpg",
            "/photos/A6/微信图片_20250820154053_69.jpg",
            "/photos/A6/微信图片_20250820154100_70.jpg",
            "/photos/A6/微信图片_20250820154104_71.jpg",
            "/photos/A6/微信图片_20250820154109_72.jpg"
        ]
    },
    "B": {
        "1": [
            "/photos/B1/000013000024.jpg",
            "/photos/B1/000013000025.jpg",
            "/photos/B1/000013000026.jpg",
            "/photos/B1/000013000027.jpg",
            "/photos/B1/微信图片_20250820154405_74.jpg"
        ],
        "2": [
            "/photos/B2/000013000020.jpg",
            "/photos/B2/000013000021.jpg",
            "/photos/B2/000013000022.jpg",
            "/photos/B2/000013000023.jpg",
            "/photos/B2/微信图片_20250820154413_75.jpg"
        ],
        "3": [
            "/photos/B3/微信图片_2025-08-20_140701_050.jpg",
            "/photos/B3/微信图片_20250820140637_52.jpg",
            "/photos/B3/微信图片_20250820140655_53.jpg",
            "/photos/B3/微信图片_20250820154421_76.jpg",
            "/photos/B3/微信图片_20250820154431_77.jpg"
        ],
        "4": [
            "/photos/B4/微信图片_20250820140742_55.jpg",
            "/photos/B4/微信图片_20250820140751_56.jpg",
            "/photos/B4/微信图片_20250820140755_57.jpg",
            "/photos/B4/微信图片_20250820140800_58.jpg",
            "/photos/B4/微信图片_20250820154435_78.jpg"
        ],
        "5": [
            "/photos/B5/000013000009.jpg",
            "/photos/B5/000013000012.jpg",
            "/photos/B5/微信图片_20250820140844_59.jpg",
            "/photos/B5/微信图片_20250820140854_60.jpg",
            "/photos/B5/微信图片_20250820154443_79.jpg",
            "/photos/B5/微信图片_20250820154458_80.jpg"
        ],
        "6": [
            "/photos/B6/000013000004.jpg",
            "/photos/B6/000013000005.jpg",
            "/photos/B6/000013000006.jpg",
            "/photos/B6/000013000007.jpg",
            "/photos/B6/000001.jpg",
            "/photos/B6/微信图片_20250820154504_81.jpg",
            "/photos/B6/微信图片_20250820154513_82.jpg",
            "/photos/B6/微信图片_20250820154519_83.jpg"
        ]
    },
    "C": {
        "1": [
            "/photos/C1/000001.JPG",
            "/photos/C1/000002.JPG",
            "/photos/C1/000004.JPG",
            "/photos/C1/微信图片_20250820154723_84.jpg"
        ],
        "2": [
            "/photos/C2/000006.JPG",
            "/photos/C2/000007.JPG",
            "/photos/C2/微信图片_20250820154736_85.jpg"
        ],
        "3": [
            "/photos/C3/000008.JPG",
            "/photos/C3/000026.JPG",
            "/photos/C3/000028.JPG",
            "/photos/C3/000029.JPG",
            "/photos/C3/微信图片_20250820154744_86.jpg"
        ],
        "4": [
            "/photos/C4/000013.JPG",
            "/photos/C4/000027.JPG",
            "/photos/C4/000030.JPG",
            "/photos/C4/000031.JPG",
            "/photos/C4/微信图片_20250820154755_87.jpg",
            "/photos/C4/微信图片_20250820154803_88.jpg"
        ],
        "5": [
            "/photos/C5/000032.JPG",
            "/photos/C5/000033.JPG",
            "/photos/C5/000034.JPG",
            "/photos/C5/微信图片_20250820154808_89.jpg"
        ],
        "6": [
            "/photos/C6/000019.JPG",
            "/photos/C6/000035.JPG",
            "/photos/C6/000036.JPG",
            "/photos/C6/000037.JPG",
            "/photos/C6/000038.JPG",
            "/photos/C6/000039.JPG",
            "/photos/C6/微信图片_20250820154822_90.jpg"
        ]
    },
    "D": {
        "1": [
            "/photos/D1/000001.JPG",
            "/photos/D1/000002.JPG",
            "/photos/D1/000003.JPG",
            "/photos/D1/000004.JPG"
        ],
        "2": [
            "/photos/D2/000005.JPG",
            "/photos/D2/000006.JPG",
            "/photos/D2/000025.JPG",
            "/photos/D2/000026.JPG",
            "/photos/D2/000030.JPG",
            "/photos/D2/微信图片_20250820154943_91.jpg",
            "/photos/D2/微信图片_20250820154954_92.jpg",
            "/photos/D2/微信图片_20250820154958_93.jpg"
        ],
        "3": [
            "/photos/D3/000027.JPG",
            "/photos/D3/000028.JPG",
            "/photos/D3/000029.JPG",
            "/photos/D3/000031.JPG",
            "/photos/D3/微信图片_20250820155004_94.jpg"
        ],
        "4": [
            "/photos/D4/微信图片_20250820142721_61.jpg",
            "/photos/D4/微信图片_20250820142730_62.jpg"
        ],
        "5": [
            "/photos/D5/000034.JPG"
        ],
        "6": [
            "/photos/D6/000008.JPG",
            "/photos/D6/000019.JPG",
            "/photos/D6/000037.JPG",
            "/photos/D6/000038.JPG",
            "/photos/D6/微信图片_20250820155015_95.jpg",
            "/photos/D6/微信图片_20250820155024_96.jpg"
        ]
    }
};

export const PHOTO_CONFIG: PhotoConfig = Object.fromEntries(
    Object.entries(RAW_PHOTO_CONFIG).map(([groupKey, photoGroup]) => [
        groupKey,
        Object.fromEntries(
            Object.entries(photoGroup).map(([relayKey, photos]) => [relayKey, toImageAssets(photos)])
        )
    ])
) as PhotoConfig;


// 图片变体生成规则
export const IMAGE_VARIANTS = {
    thumbnail: '_thumb',
    preview: '_preview',
    original: ''  // 无后缀
};

/**
 * 获取指定组别和序号的图片路径
 * @param group 组别 (A, B, C, D)
 * @param index 序号 (1-6)
 * @returns 图片路径数组
 */
export function getPhotoPaths(group: string, index: number): ImageAsset[] {
    return PHOTO_CONFIG[group as keyof typeof PHOTO_CONFIG]?.[index] || [];
}

/**
 * 获取所有图片配置
 * @returns 完整的图片配置对象
 */
export function getAllPhotoConfig() {
    return PHOTO_CONFIG;
}

/**
 * 添加新的图片路径
 * @param group 组别
 * @param index 序号
 * @param newPaths 新的图片路径数组
 */
export function addPhotoPaths(group: string, index: number, newPaths: ImageAssetLike[]) {
    if (!PHOTO_CONFIG[group as keyof typeof PHOTO_CONFIG]) {
        (PHOTO_CONFIG as any)[group] = {};
    }
    
    if (!PHOTO_CONFIG[group as keyof typeof PHOTO_CONFIG][index]) {
        (PHOTO_CONFIG as any)[group][index] = [];
    }
    
    // 添加新路径，避免重复
    toImageAssets(newPaths).forEach((path) => {
        if (!PHOTO_CONFIG[group as keyof typeof PHOTO_CONFIG][index].some((asset) => asset.original === path.original)) {
            (PHOTO_CONFIG as any)[group][index].push(path);
        }
    });
    
    console.log(`Added ${newPaths.length} new paths to ${group}${index}`);
}

/**
 * 验证图片路径是否存在
 * @param path 图片路径
 * @returns Promise<boolean> 是否存在
 */
export async function validatePhotoPath(path: ImageAssetLike): Promise<boolean> {
    const url = resolveImageAssetUrl(path);
    if (!url) return false;

    return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => resolve(true);
        image.onerror = () => resolve(false);
        image.src = url;
    });
}

/**
 * 获取有效的图片路径（经过验证）
 * @param group 组别
 * @param index 序号
 * @returns Promise<string[]> 有效的图片路径数组
 */
export async function getValidPhotoPaths(group: string, index: number): Promise<ImageAsset[]> {
    const paths = getPhotoPaths(group, index);
    const validPaths: ImageAsset[] = [];
    
    for (const path of paths) {
        const isValid = await validatePhotoPath(path);
        if (isValid) {
            validPaths.push(path);
        }
    }
    
    console.log(`Validated ${paths.length} paths for ${group}${index}, found ${validPaths.length} valid ones`);
    return validPaths;
}
